'use client';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button as ReactAriaButton } from 'react-aria-components';
import { toColorClassName } from '../../config/Colors.js';
import { toClassName } from '../../utils/ClassNameUtils.js';
import { Icon } from '../Icon/Icon.js';
export function Button2({ className, color, iconLeft, iconRight, children, ...props }) {
    const realClassName = toClassName('button', toColorClassName(color), className);
    const content = (_jsxs(_Fragment, { children: [iconLeft ? _jsx(Icon, { icon: iconLeft }) : null, (iconLeft || iconRight) && children ? _jsx("span", { children: children }) : children, iconRight ? _jsx(Icon, { icon: iconRight }) : null] }));
    return (_jsx(ReactAriaButton, { className: realClassName, props, children: content }));
}
//# sourceMappingURL=Button2.js.map